import { globalScope } from '../window/browser';

export function getConsole() {
  globalScope.console = globalScope.console || {};

  return globalScope.console;
}

export function log(message) {
  if (typeof getConsole().log !== 'function') {
    return;
  }

  getConsole().log(message);
}

export function warn(message, payload) {
  if (typeof getConsole().warn !== 'function') {
    return;
  }

  getConsole().warn(message, payload);
}

export function debug(message, payload) {
  if (typeof getConsole().debug !== 'function') {
    return;
  }

  getConsole().debug(message, payload);
}
